@if (contractAttributes$ | async; as attributes) {
  <ng-container [formGroup]="form">
    <app-attribute-project-editable [label]="attributes.contractScope?.title" [attribute]="attributes.contractScope" formControlName="contractScope">
    </app-attribute-project-editable>
    <app-attribute-project-editable [label]="attributes.implementation?.title" [attribute]="attributes.implementation" formControlName="implementation">
    </app-attribute-project-editable>
    <app-attribute-project-editable [label]="attributes.buyerParticipation?.title" [attribute]="attributes.buyerParticipation" formControlName="buyerParticipation">
    </app-attribute-project-editable>
    <app-attribute-project-editable [label]="attributes.realizationPosition?.title" [attribute]="attributes.realizationPosition" formControlName="realizationPosition">
    </app-attribute-project-editable>
    <app-attribute-project-editable [label]="attributes.contractPrecondition?.title" [attribute]="attributes.contractPrecondition" formControlName="contractPrecondition">
    </app-attribute-project-editable>
    <app-attribute-project-editable [label]="attributes.methodOfAcquisition?.title" [attribute]="attributes.methodOfAcquisition" formControlName="methodOfAcquisition">
    </app-attribute-project-editable>
    <app-attribute-editable label="Aanneemsom" formControlName="contractPrice" inputType="number" valuePrefix="€"></app-attribute-editable>
    <app-attribute-editable label="Meer- en minderwerk" formControlName="additionalWork" inputType="number" valuePrefix="€"></app-attribute-editable>
  </ng-container>
}


